import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import React from "react"

import { capitaliseEachWord } from "../../config/util-functions"

type Props = {
    isOpen: boolean,
    name: string,
    toggle: void => void,
    type: "source" | "map",
    onDelete: void => void
}

const DeleteModal = ({ isOpen, name, toggle, type, onDelete }: Props) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            className="modal-dialog-v-centered modal-horizontally-centered"
        >
            <ModalHeader>Delete {capitaliseEachWord(type)}</ModalHeader>
            <ModalBody>
                Are you sure that you want to delete{" "}
                {(name && (
                    <span>
                        the <strong>{name}</strong>
                    </span>
                )) || <span>this</span>}{" "}
                {type} and all its data?
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-cancel col" onClick={toggle}>
                    Cancel
                </button>
                <button className="btn btn-primary col" onClick={onDelete}>
                    Delete
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteModal
